//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export enum CollectionType {
  COLLECTION = 'Collection',
  GOOGLE_FEED_STREAM = 'GoogleFeedStream',
  RECOMMENDATIONS_STREAM = 'RecommendationsStream',
  STREAM = 'Stream',
  PINTEREST_STL = 'PinterestSTL',
}
